"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUIElementAccess = void 0;
const selectElementAccess_1 = require("../selectors/selectElementAccess");
const useSelector_1 = require("./useSelector");
function useUIElementAccess(feature, element) {
    return (0, useSelector_1.useSelector)(state => (0, selectElementAccess_1.selectElementAccess)(state, feature, element));
}
exports.useUIElementAccess = useUIElementAccess;
